import LabelProvider from "core/components/label/LabelProvider";

export default LabelProvider.create({

    CompletionStatus:{
        k: "programStatus.completed",
        v: "${Completed} of ${Total} topics",
        argNames:['Completed','Total']
    },
    SubscriptionTakePreTest:{
        k: "subscriptionTags.none",
        v: "Please take the pre-test to see your results."
    }
});


// WEBPACK FOOTER //
// ./src/panels/subscriptionTags/SubscriptionTags.labels.ts